<script context="module">
  import State from '$lib/utils/state.svelte.js'

  export function asSrcset(url, variants, opts) {
    return variants
      .map((size) => {
        let _opts = { ...opts }
        if (Array.isArray(size)) {
          _opts.transforms = opts?.transforms
            ? size[1] + ',' + opts.transforms
            : size[1]
          size = size[0]
        }
        return `${asSrc(url, size, _opts)} ${size}w`
      })
      .join(',')
  }

  export function asSrc(uri, size, opts = {}) {
    if (uri.includes('.svg')) return uri

    let { transforms, aspect } = opts
    if (transforms == null) transforms = 'c_fill,f_avif,q_auto'

    // apply default transforms
    if (!/c_/.test(transforms)) transforms += ',c_fill'
    if (!/q_/.test(transforms)) transforms += ',f_avif'
    if (!/q_/.test(transforms)) transforms += ',q_auto'

    uri = uri
      .replace('?auto=format,compress', '')
      .replace('?auto=compress,format', '')
      .replace('?auto=format%2Ccompress', '')
      .replace('?auto=compress%2Cformat', '')
      .replace('&rect', '?rect')

    // apply width parameter
    transforms += `,w_${size}`
    if (aspect) transforms += `,h_${Math.floor(size * aspect)}`

    return `${State.origin}/media/fetch/${encodeURIComponent(transforms)}/${encodeURIComponent(
      uri
    )}`
  }
</script>

<script>
  /** @type {string} */
  export let src

  /** @type {string} */
  export let alt

  /** @type {(number|[number, string])[]?} */
  export let variants = []

  /** @type {number?} */
  export let aspect = null

  /** @type {string?} */
  export let transforms = null
</script>

{#if src}
  <img
    {...$$restProps}
    srcset={asSrcset(src, variants, { aspect, transforms })}
    src={asSrc(src, variants?.[0] || 700)}
    {alt} />
{/if}
